import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, filter, map, Observable } from 'rxjs';
import { getTranslationProvider } from '../core/i18n/getTranslationProvider';
import { TranslatableComponent } from '../core/i18n/TranslatableComponent';
import { LoginStatus } from '../core/interceptors/auth.interceptor';
import { AuthActions } from '../core/state/auth/auth.actions';
import { AuthSelectors } from '../core/state/auth/auth.selectors';
import { ToastActions } from '../core/state/toast/toast.actions';

@Component({
  templateUrl: './login.component.html',
  providers: [getTranslationProvider('LoginComponent')],
})
export class LoginComponent extends TranslatableComponent {
  public loggingIn$: Observable<boolean>;

  constructor(private activatedRoute: ActivatedRoute) {
    super();
    this.loggingIn$ = this.store.select(AuthSelectors.selectLoadSpinnerState);
    this.clearSessionAndLoggedInUser();
    this.showSessionExpiredMessageIfRouteHasErrorParams();
  }

  public login() {
    this.store.dispatch(AuthActions.initLogin());
  }

  private clearSessionAndLoggedInUser() {
    this.store.dispatch(AuthActions.resetAuthStateAndStorage());
  }

  private showSessionExpiredMessageIfRouteHasErrorParams() {
    combineLatest([this.activatedRoute.queryParams, this.translationsLoaded$])
      .pipe(
        filter(([queryParams, translations]) => queryParams?.error && Boolean(translations)),
        map(([{ error }, translations]) => ({ error, translations })),
        this.takeUntilDestroyed(),
      )
      .subscribe(({ error, translations }) => {
        if (error === LoginStatus.UnAuthorized) {
          this.store.dispatch(
            ToastActions.showErrorMessage({
              summary: translations.expiredSessionTitle,
              detail: translations.expiredSessionDescription,
            }),
          );
        }

        if (error === LoginStatus.UnAuthorizedInactive) {
          this.store.dispatch(
            ToastActions.showErrorMessage({
              summary: translations.inactiveUserTitle,
              detail: translations.inactiveUserDescription,
            }),
          );
        }
      });
  }
}
